import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'atom-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent {
  @Input() labelLeft: string = '';
  @Input() labelRight: string = '';
  @Input() isChecked: boolean = false;
  @Output() changed = new EventEmitter<boolean>();

  onChanged(event: MatSlideToggleChange): void {
    const value = event.checked;
    this.changed.emit(value);
  }
}